export const menu = () => `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12H18" stroke="inherit" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 8H18" stroke="inherit" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 16H18" stroke="inherit" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
`;
